import { combineReducers } from 'redux';
import addedUser from './Users/AddUser';

const defaultUsersLoading = false;
const usersLoading = (state = defaultUsersLoading, action) => {
  switch (action.type) {
    case 'GET_USERS':
    case 'GET_USERS_BY_COMPANY':
      return true;
    case 'GET_USERS_SUCCESS':
    case 'GET_USERS_BY_COMPANY_SUCCESS':
    case 'GET_USERS_ERROR':
    case 'GET_USERS_BY_COMPANY_FAILURE':
      return false;
    default:
      return state;
  }
};

const defaultDeleteUserID = null;
const deleteUserID = (state = defaultDeleteUserID, action) => {
  switch (action.type) {
    case 'DELETE_USER_SHOW':
      return action.id;
    case 'DELETE_USER_SUCCESS':
    case 'DELETE_USER_CANCEL':
      return null;
    default:
      return state;
  }
};

const defaultdeleteShow = false;
const deleteShow = (state = defaultdeleteShow, action) => {
  switch (action.type) {
    case 'DELETE_USER_SHOW':
      return true;
    case 'DELETE_USER_CANCEL':
    case 'DELETE_USER_SUCCESS':
      return false;
    default:
      return state;
  }
};

const masterBoxStatus = false;
const masterBoxPress = (state = masterBoxStatus, action) => {
  switch (action.type) {
    case 'MASTER_BOX_PRESS_SUCCESS':
      return action.status;
    case 'MASTER_BOX_PRESS_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultAddUserShow = false;
const addUserShow = (state = defaultAddUserShow, action) => {
  switch (action.type) {
    case 'ADD_USER_SHOW':
      return true;
    case 'ADD_USER_CANCEL':
    case 'ADD_USER_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultAddUserCompanyFilter = {};
const companyFilter = (state = defaultAddUserCompanyFilter, action) => {
  if (action.type === 'ADD_USER_COMPANY_FILTER') {
    return action.filter;
  }
  return state;
};

const defaultUpdateUser = {};
const updateUser = (state = defaultUpdateUser, action) => {
  switch (action.type) {
    case 'UPDATE_USER_INITIAL_DATA':
      return { ...action.userObj };
    case 'UPDATE_USER_CHANGE_FIELD':
      const { name, value } = action;
      return { ...state, [name]: value };
    default:
      return state;
  }
};

const defaultUpdateUserData = {};
const updateUserData = (state = defaultUpdateUserData, action) => {
  switch (action.type) {
    case 'UPDATE_USER_CHANGE_FIELD':
      const { name, value } = action;
      return { ...state, [name]: value };
    case 'UPDATE_USER_BY_ID_SUCCESS':
      return defaultUpdateUser;
    default:
      return state;
  }
};

const defaultUpdateUserShow = false;
const updateUserShow = (state = defaultUpdateUserShow, action) => {
  switch (action.type) {
    case 'UPDATE_USER_SHOW':
      return true;
    case 'UPDATE_USER_CANCEL':
    case 'UPDATE_USER_SUCCESS':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  deleteUserID,
  usersLoading,
  deleteShow,
  addUserShow,
  addedUser,
  companyFilter,
  updateUser,
  updateUserShow,
  updateUserData,
  masterBoxPress,
});
